import styled, { css } from 'styled-components';
import { PlainIconButton, iconButtonSizeConfig } from '../../fuse-buttons/src/buttons';
import { gridConfig as breakpoints } from '../../fuse-responsive-grid/src/grid';
import { convertRemToPx } from '../../fuse-typography/src/typography';
import { defaultCssProps } from '../../fuse-typography/src/typography-config';
import { TypographyComponent as Typography } from '../../fuse-typography-element/src/typography';

const StyledDrawerHeader = styled.div.attrs({
	className: 'fuse-drawer__header',
})`
	align-items: center;
	background-color: var(--color-functional-panelLight);
	border-bottom: 1px solid var(--color-global-grey400);
	color: var(--color-global-black);
	display: flex;
	left: 0;
	padding: ${breakpoints.xxs.margin};
	position: sticky;
	right: 0;
	top: 0;
	transition: box-shadow 50ms ease-in-out;

	${({ hasDepth }) =>
		hasDepth &&
		css`
			box-shadow: var(--elevation-shadow-l);
			z-index: 1;
		`}

	@media only screen and (min-width: ${breakpoints.m.minWidth}) {
		padding: ${breakpoints.m.margin};

		${({ hasDepth }) =>
		hasDepth &&
			css`
				box-shadow: var(--elevation-shadow-xl);
				z-index: 1;
			`}
	}
`;

const StyledDrawerIconButton = styled(PlainIconButton)`
	${() => {
		const modalHeadingHeight = convertRemToPx(defaultCssProps?.t3?.lineHeight);
		const buttonHeight = iconButtonSizeConfig.small?.iconHeight?.replace('px', '');
		const buttonMarginTop = `${(modalHeadingHeight - buttonHeight) / 2}px`;

		return css`
			margin-top: ${buttonMarginTop};
		`;
	}}
`;

const StyledDrawerHeading = styled(Typography).attrs({
	className: 'fuse-drawer__heading',
})`
	${({ hasBackButton, hasIcon }) => `
		flex: 1 1 auto;
		${hasBackButton || hasIcon ? `margin-left: var(--spacing-global-space3);` : ``}
	`}
`;

export { StyledDrawerHeader, StyledDrawerHeading, StyledDrawerIconButton };
